import { Chip, ChipProps } from '@mui/material';

enum Status {
  ACTIVE,
  DEACTIVATED,
  REPORT_DENIED,
}

type StatusChipProps = {
  deactivated?: boolean;
  reportDenied?: boolean;
};
const StatusChip = ({ deactivated, reportDenied }: StatusChipProps) => {
  const label: Status = deactivated ? Status.DEACTIVATED : reportDenied ? Status.REPORT_DENIED : Status.ACTIVE;
  return <Chip variant="outlined" {...StatusChips[label]} />;
};

export default StatusChip;

const StatusChips: Record<Status, ChipProps> = {
  [Status.ACTIVE]: {
    label: 'Active',
    color: 'success',
  },
  [Status.DEACTIVATED]: {
    label: 'Deactivated',
    color: 'error',
  },
  [Status.REPORT_DENIED]: {
    label: 'Report Denied',
    color: 'default',
  },
};
